import request from '@/utils/request'

// 账号密码登录
export function login(data) {
  return request({
    url: '/auth/login',
    method: 'post',
    data
  })
}

// SSO回调接口（一表通令牌验证）
export function ssoCallback(token) {
  return request({
    url: '/auth/sso-callback',
    method: 'post',
    params: { token }
  })
}

// 获取SSO登录地址
export function getSsoLoginUrl() {
  return request({
    url: '/auth/sso-login-url',
    method: 'get'
  })
}

// 登出接口
export function logout() {
  return request({
    url: '/auth/logout',
    method: 'get'
  })
}

// 获取当前用户信息接口
export function getInfo() {
  return request({
    url: '/auth/current',
    method: 'get'
  })
}

// 更新当前用户资料（姓名/手机号/邮箱/性别）
export function updateProfile(data) {
  return request({
    url: '/auth/profile',
    method: 'put',
    data
  })
}

// 修改当前用户密码（原密码/新密码）
export function updatePassword(data) {
  return request({
    url: '/auth/password',
    method: 'put',
    data
  })
}

// 获取菜单列表接口
export function getMenuList() {
  return request({
    url: '/auth/menus',
    method: 'get'
  })
}

// 获取用户权限列表
export function getPermissionList() {
  return request({
    url: '/auth/permissions',
    method: 'get'
  })
}

// 获取认证状态（测试/生产模式判断）
export function getAuthStatus() {
  return request({
    url: '/auth/auth-status',
    method: 'get'
  })
}

// 测试环境角色登录（orgId 可选：指定旗区后以该旗区管理员身份登录）
export function testLogin(roleCode, orgId) {
  const data = { role: roleCode }
  if (orgId) {
    data.orgId = orgId
  }
  return request({
    url: '/auth/test-login',
    method: 'post',
    data
  })
}

// 测试环境旗区列表（登录页选择具体旗区管理员）
export function getTestDistricts() {
  return request({
    url: '/auth/test-districts',
    method: 'get'
  })
}